window.OKJS = window.OKJS || {};
(function (OKJS) {
  OKJS.Overlay = {
    init: function () {
      this.setupOverlays();
    },
    setupOverlays: function () {
      try {
        // init the modal plugin
        var modal = new VanillaModal.default({
          onBeforeClose: function () {
            /*htmlTag = document.getElementsByTagName("html")[0];
                        if (htmlTag.classList.contains('youtube')) {
                            targetModalIframes = document.querySelectorAll('.youtube-wrap iframe');

                            for (var i = 0; i < targetModalIframes.length; i++) {
                                targetModalIframes[i].setAttribute('src', 'about:blank');
                            }
                        }*/

            setTimeout(function () {
              OKJS.Overlay.overlayCleanup();
            }, 150);
          },
        });

        // set the clickevent on the triggers
        var overlayTriggers = document.querySelectorAll('.js-overlay-open');
        if (overlayTriggers) {
          for (var i = 0; i < overlayTriggers.length; i++) {
            // Check if the data-overlay-target attribute is set. This is relevant for elements
            // that doesn't have a href or hash. For instance a button
            if (overlayTriggers[i].hasAttribute('data-overlay-target')) {
              if (!overlayTriggers[i].hash) {
                overlayTriggers[i].hash = overlayTriggers[i].getAttribute(
                  'data-overlay-target'
                );
              }
            }

            overlayTriggers[i].addEventListener('click', function (event) {
              OKJS.Overlay.triggerEvent(event, modal);
            });
          }
        }
      } catch (error) {
        console.warn(
          'Error during overlay setup - probably because we have no vanilla modals on page',
          error
        );
      }
    },
    triggerEvent: function (e, modal) {
      e.preventDefault();

      var overlayType = e.currentTarget.dataset.overlaytype,
        overlayContentType = e.currentTarget.dataset.overlaycontent,
        anno2023Design = e.currentTarget.dataset.anno2023design,
        htmlTag = document.getElementsByTagName('html')[0],
        pageMargin =
          document.body.scrollTop || document.documentElement.scrollTop;

      // push the html tag upwards so that it looks like you at the same position on the page eventhough the html is fixed.
      htmlTag.style.top = -pageMargin + 'px';
      htmlTag.dataset.pagemargin = pageMargin;
      htmlTag.classList.add(overlayType);

      if (overlayContentType === 'youtube') {
        htmlTag.classList.add(overlayContentType);
        var youtubeIframes = document.querySelectorAll(
            'iframe[data-consent-src]'
          ),
          warningHtml =
            '<p class="limit-article-area">Vi gør brug af Youtube til at afspille videoer, og for at kunne se denne video kræver det, at du aktiverer marketing cookies. Se mere på vores <a href="https://www.ok.dk/cookies">ok.dk/cookies</a> side.</p>';

        if (youtubeIframes) {
          for (var i = 0; i < youtubeIframes.length; i++) {
            // firstly make sure that the iframe hasn't already been "fixed"
            if (
              youtubeIframes[i].getAttribute('src').indexOf('youtube') === -1
            ) {
              console.log('ran');
              // make sure cookieinformation is loaded
              if (typeof CookieInformation === 'undefined') {
                youtubeIframes[i].parentElement.parentElement.innerHTML =
                  warningHtml;
              } else {
                // check consent from the user
                if (
                  CookieInformation.getConsentGivenFor(
                    youtubeIframes[i].getAttribute('data-category-consent')
                  )
                ) {
                  // finally set the iframe src to the src from the consent attribute
                  console.log('src set');
                  youtubeIframes[i].setAttribute(
                    'src',
                    youtubeIframes[i].getAttribute('data-consent-src')
                  );
                } else {
                  youtubeIframes[i].parentElement.parentElement.innerHTML =
                    warningHtml;
                }
              }
            }
          }
        }
      }

      // call vanilla Modal with the correct settings
      if (overlayType === 'overlay--blurred') {
        modal.dom.modal = document.querySelector('.modal.modal--blurred');
        modal.dom.modalInner = document.querySelector(
          '.modal--blurred .modal-inner'
        );
        modal.dom.modalContent = document.querySelector(
          '.modal--blurred .modal-content'
        );
      } else {
        modal.dom.modal = document.querySelector('.modal.modal--black');
        modal.dom.modalInner = document.querySelector(
          '.modal--black .modal-inner'
        );
        modal.dom.modalContent = document.querySelector(
          '.modal--black .modal-content'
        );
      }
      if (anno2023Design) {
        modal.dom.modalInner.classList.add('anno-2023-design');
      }
      modal.open(e.currentTarget);
    },
    overlayCleanup: function () {
      var htmlTag = document.getElementsByTagName('html')[0];

      // remove the pushy styling
      //must separate into two calls, because IE
      htmlTag.classList.remove('overlay--black');
      htmlTag.classList.remove('overlay--blurred');
      htmlTag.classList.remove('youtube');
      window.scrollTo(0, htmlTag.dataset.pagemargin);
    },
  };
})(window.OKJS);
